import { queryOptions } from "@tanstack/react-query";
import type { UpdateProfileInput, User } from "@yalana/contracts";
import { fetchApi } from "../../../shared/infrastructure/api-client";

export const authQueries = {
  all: () => ["auth"] as const,
  me: () =>
    queryOptions({
      queryKey: [...authQueries.all(), "me"] as const,
      queryFn: () => fetchApi<User>("/api/auth/me", { skipRedirect: true }),
      retry: false, // Don't retry on 401
      staleTime: 5 * 60 * 1000,
    }),
  roles: (userId: string) =>
    queryOptions({
      queryKey: [...authQueries.all(), "users", userId, "roles"] as const,
      queryFn: () =>
        fetchApi<{
          roles: Array<{
            roleName: string;
            roleEntityId: string;
            isSystem?: boolean;
          }>;
        }>(`/api/auth/users/${userId}/roles`, { skipRedirect: true }),
      enabled: !!userId,
    }),
};

export const authMutations = {
  updateProfile: () => ({
    mutationFn: (input: UpdateProfileInput) =>
      fetchApi("/api/auth/me", {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
  }),
  updateActiveCustomer: () => ({
    mutationFn: (customerId: string) =>
      fetchApi("/api/auth/active-customer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customerId }),
        skipRedirect: true,
      }),
  }),
};
